var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isPhoneVerified === 1)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_c('p',{staticClass:"text--secondary",domProps:{"textContent":_vm._s(_vm.confirmationMessage)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }